import { trialRoundDates, mainRoundDates } from '@app/components/shared/StateLabel/Label'

const RulesID = (event) => {
  return (
    `
      <h2 class="info-about-static__title"><b>Kapan Kompetisi akan diadakan?</b></h2>

      <p class="info-about-static__text">
        Kompetisi diadakan dalam dua babak: latihan dan utama. Hasil babak latihan tidak mempengaruhi hasil babak utama.
      </p>

      <p class="info-about-static__text">
        Untuk siswa kelas 1-12, Ujian dan babak Utama akan berlangsung pada Musim Gugur 2022.
      </p>

      <h3 class="info-about-static__pre-title"><b>Bentuk Olimpiade</b></h3>
      <p class="info-about-static__text">
        Olimpiade ini digelar secara onlilne di laman bricsmath.com dan tentunya, tidak dipungut biaya sama sekali. Untuk bergabung di olimpiade ini, siswa hanya membutuhkan komputer/laptop, tablet/ponsel pintar dengan browser versi terbaru serta koneksi internet. Soal-soal yang menyenangkan dan interaktif dalam olimpiade ini dirancang dalam bentuk permainan yang ramah anak. Soal-soal ini akan melatih siswa untuk berpikir diluar kebiasaan atau diluar standar, serta tidak memerlukan pengetahuan dari silabus Matematika di sekolah maupun persiapan. Olimpiade ini tersedia untuk semua kelas dalam bahasa Portugis, Bahasa Rusia, Bahasa Inggris, Hindi, Bahasa Cina, Bahasa Indoneisa, dan Bahasa Vietnam.
      </p>

      <h3 class="info-about-static__pre-title"><b>Pendaftaran Guru Dan Siswa</b></h3>
      <p class="info-about-static__text">
        Para guru bisa mendaftarkan siswanya di bricsmath.com dengan memilih negara, kelas, dan bahasa masing-masing. Kemudian, guru bisa mencetak login dan kata sandi siswa yang kemudian bisa dikirimkan ke masing-masing siswa. Mereka dapat masuk ke website bricsmath.com menggunakan login dan kata sandi yang bapak/ibu berikan.
      </p>

      <p class="info-about-static__text">
        Olimpiade berbentuk online ini membolehkan semua siswa bergabung terlepas dari tingkat pengetahuan, latar belakang sosial dan juga geografisnya, dengan alasan tersebut, kami mendorong bapak/ibu sekalian untuk memberikan semua siswa kesempatan untuk bergabung.
      </p>

      <p class="info-about-static__text">
        Untuk info lebih lanjut, silakan menghubungi kami di <a href="mailto:info@bricsmath.com">info@bricsmath.com</a>
      </p>
    `
  )
}

export default RulesID
